import template from './adpDropdownTabs.html';
import controller from './adpDropdownTabs.controller';
import './adpDropdownTabs.less';

let adpDropdownTabsComponent = {
  restrict: 'E',
  bindings: {
    tabs: '<',
    visible: '=?',
    onOpen: '&',
    onClose: '&'
  },
  template,
  transclude: true,
  controller
};

export default adpDropdownTabsComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpDropdownTabs/adpDropdownTabs.component.js